import {
	type ClientPropertyFlatDetailResponseDTO,
	ClientPropertyTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { BuildingEditFormFields } from "web_myplann/Portfolio/Forms/BuildingShared/BuildingEditFormFields";
import { useEditFlatForm } from "web_myplann/Portfolio/Forms/FlatForm/useEditFlatForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

type EditFlatFormProps = {
	propertyId: number;
	property: ClientPropertyFlatDetailResponseDTO;
	detailRoute: string;
};

export const EditFlatForm = ({
	propertyId,
	property,
	detailRoute,
}: EditFlatFormProps) => {
	const { t } = useResource();
	const { form, onSubmit, isPending, leaveConfirmation } = useEditFlatForm({
		propertyId,
		property,
		detailRoute,
	});

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.EditRealEstate.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
			leaveConfirmation={leaveConfirmation}
		>
			<BuildingEditFormFields
				control={form.control}
				type={ClientPropertyTypeEnum.Flat}
			/>
		</PortfolioFormShell>
	);
};
